import React from "react";
import classNames from "classnames";
import { OrderChatMessage } from "@core/types";
import Attachment from "./attachments/Attachment";
import MessageStatusIcon from "./MessageStatusIcon";
import { formatTime } from "../utils/format";

type MessageBubbleProps = {
  message: OrderChatMessage;
  operatorLastReadAt: string | null;
};

const MessageBubble = ({ message, operatorLastReadAt }: MessageBubbleProps) => {
  const isOwn = message.senderType === "customer";

  return (
    <div className={classNames("flex", isOwn ? "justify-end" : "justify-start")}>
      <div
        className={classNames(
          "max-w-[85%] p-1 rounded-2xl flex flex-col gap-0.5",
          isOwn ? "bg-primary text-white rounded-br-sm" : "bg-gray-100 text-black rounded-bl-sm",
        )}
      >
        {message.text && (
          <div className="text-sm whitespace-pre-wrap break-words text-black px-2.5 pt-1">{message.text}</div>
        )}
        {message.attachments.map((attachment) => (
          <Attachment key={attachment.id} attachment={attachment} />
        ))}
        <div
          className={classNames(
            "text-[10px] mt-0.5 flex items-center gap-1",
            isOwn ? "text-black self-end mr-1" : "text-gray-500 self-start ml-1",
          )}
        >
          <span className={isOwn ? "pl-2" : ""}>{formatTime(message.createdAt)}</span>
          {isOwn && <MessageStatusIcon message={message} operatorLastReadAt={operatorLastReadAt} />}
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
